import { tsrContractsClient } from '../tsrContractsClient';

const ihiReviewLogClient = () => tsrContractsClient.ihiReviewLogContract;

export { ihiReviewLogClient };
